import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {LoggerService} from '../../shared/common-components/logger.service';
import {DataService} from '../data.service';
import {FrtOtoRequest} from "./frt-oto-request";


@Injectable({
    providedIn: 'root'
})
export class FrtOtoRateQueryService extends DataService {

    private baseURI = this.apiUri + '/frtOtoRequest/';
    private _logger: LoggerService;

    constructor(http: HttpClient, logger: LoggerService) {
        super(http);
        this._logger = logger;
    }

    saveOtoRequest(frtOtoRequest: any): Observable<any> {
      return this.http.post(this.baseURI + 'save', frtOtoRequest)
    }

}
